import { primaryCategoryRepository } from '@webapp/core/data-access/repositories/PrimaryCategoryRepository'
import { secondaryCategoryRepository } from '@webapp/core/data-access/repositories/SecondaryCategoryRepository'
import { GetTravelRequestFormDataUseCase } from './GetTravelRequestFormData'

export const getTravelRequestFormDataUseCase =
  new GetTravelRequestFormDataUseCase({
    primaryCategoryRepository,
    secondaryCategoryRepository,
  })

export {
  GetTravelRequestFormDataUseCase,
  type GetTravelRequestFormDataParams,
  type TravelRequestFormData,
} from './GetTravelRequestFormData'
